import { render, staticRenderFns } from "./PxCamposCompraItemTableLm.vue?vue&type=template&id=086f8b07&"
import script from "./PxCamposCompraItemTableLm.vue?vue&type=script&lang=js&"
export * from "./PxCamposCompraItemTableLm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports